// extracted by mini-css-extract-plugin
var _1 = "NotificationTypesSelector_grid__BVOKe";
var _2 = "NotificationTypesSelector_item__d-2kg";
var _3 = "NotificationTypesSelector_itemActive__-ZQ1g";
var _4 = "NotificationTypesSelector_label__P9hiy";
var _5 = "NotificationTypesSelector_labelActive__CW1w5";
export { _1 as "grid", _2 as "item", _3 as "itemActive", _4 as "label", _5 as "labelActive" }
